import { render, staticRenderFns } from "./xinliceping-detail.vue?vue&type=template&id=31c1ab5e&scoped=true&"
import script from "./xinliceping-detail.vue?vue&type=script&lang=ts&"
export * from "./xinliceping-detail.vue?vue&type=script&lang=ts&"
import style0 from "./xinliceping-detail.vue?vue&type=style&index=0&id=31c1ab5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1ab5e",
  null
  
)

export default component.exports